










































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { mdiArrowLeft, mdiArrowRight } from '@mdi/js'
import { IStyle } from '~/assets/interfaces/classes'
import { filterUrl } from '~/assets/filters/url'

interface IPaginationItem {
  title: string
}

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
  },
})
export default class ComponentNavigationPagination extends Vue {
  @Prop({ type: Number, default: 1 }) private amount!: number

  private mdiArrowLeft = mdiArrowLeft
  private mdiArrowRight = mdiArrowRight

  private get amountPreviewPages() {
    return this.$device.isMobileOrTablet ? 2 : 4
  }

  private get pagesRendering() {
    const pages = []

    for (let i = 1; i <= this.amount; i++) {
      if (
        (i === 1 && !this.$device.isMobileOrTablet) ||
        (i === this.amount && !this.$device.isMobileOrTablet) ||
        (i > this.currentPage - this.amountPreviewPages &&
          i < this.currentPage + this.amountPreviewPages)
      ) {
        pages.push({ title: i.toString() })
      } else if (pages[pages.length - 1] !== null) {
        pages.push(null)
      }
    }

    return pages
  }

  private get currentPage() {
    return Number(this.$route.query.page || 1)
  }

  private $style!: IStyle

  private goPage(num: number | string) {
    const query = { ...this.$route.query }
    query.page = num.toString()
    if (query.showMore) {
      query.showMore = '0'
    }
    this.$router.push({
      path: filterUrl(this.$route.path),
      query,
    })
  }

  private classPage(page: IPaginationItem | null) {
    return {
      [this.$style.item]: true,
      [this.$style.active]: page
        ? page.title === this.currentPage.toString()
        : false,
      [this.$style.disable]: page === null,
    }
  }

  private get classPagination() {
    return {
      [this.$style.pagination]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }
}
